import Typography from '@mui/material/Typography';
import { SupportLink } from '../../common/SupportLink';
import { ErrorP } from '../../common/Typography';

interface ResumeErrorProps {
  error?: Error;
}
export const ResumeError = ({ error }: ResumeErrorProps) => {
  if (!error) {
    return null;
  }
  if (error.message.match(/is not a valid uuid/i)) {
    // @ts-expect-error
    const notFoundId = window.location.href.split('/').at(-1);
    return (
      <>
        <Typography variant='h4' component='h2'>
          Invalid Identifier
        </Typography>
        <Typography>
          The identifier ({notFoundId}) for this application is not valid.
          Please ensure that the address is correct and try again. If you
          believe this to be an error, please contact support at{' '}
          <SupportLink
            subject={`Error with UUID: ${error.message}; ${notFoundId}`}
          />
          .
        </Typography>
      </>
    );
  }
  if (error.message.match(/quote matching query does not exist/i)) {
    // @ts-expect-error
    const notFoundId = window.location.href.split('/').at(-1);
    return (
      <>
        <Typography variant='h4' component='h2'>
          Unable to Find Application
        </Typography>
        <Typography>
          We're sorry, but we can't find an application with the provided ID.
          Please ensure that the address is correct and try again. If you
          believe this to be an error, please contact support at{' '}
          <SupportLink subject={`Application not found for ${notFoundId}`} />.
        </Typography>
      </>
    );
  }
  return (
    <>
      <Typography variant='h4' component='h2'>
        Error Resuming Application
      </Typography>
      <Typography>
        Sorry, something went wrong when resuming your application.
      </Typography>
      <ErrorP>{error.message}</ErrorP>
      <Typography>
        If you see this message consistently or believe this to be an error,
        please contact support at{' '}
        <SupportLink
          subject={`Error resuming PolicyStream application: ${error.message}`}
        />
        .
      </Typography>
    </>
  );
};
